import React from "react";
import styles from "./SuccessPageMobile.module.css";
import logo from "../../assets/images/logo.png";
import successimg from "../../assets/images/successimg.png";
import { NavLink } from "react-router-dom";
import Confetti from "react-confetti";
import FooterMobile from "../FooterMobile/FooterMobile";

const SuccessPageMobile = () => {
  return (
    <>
      <div className={styles.successpage}>
        <div className={styles.main_container}>
          <div className={styles.successpage_headContainer}>
            <img className={styles.header_image} src={logo} alt="logo " />
            <div className={styles.header_text}>Musicart</div>
          </div>

          <div className={styles.container}>
            <img src={successimg} alt="successimg" />
            <div className={styles.msg}>
              <span className={styles.success_msg}>
                Order is placed successfully!
              </span>
              <span className={styles.confirm_msg}>
                You will be receiving a confirmation email with order details
              </span>
            </div>
            <button className={styles.back_btn}>
              <NavLink className={styles.link_back_btn} to="/home">
                Go back to Home page{" "}
              </NavLink>
            </button>
          </div>
        </div>
        <FooterMobile />
        <Confetti />

      </div>
    </>
  );
};

export default SuccessPageMobile;
